import React, { Component } from 'react';

import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

class Results extends Component {
    render() {
        return (
            <div className="garant-fond-results">
                <div className="garant-fond-results__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonTitle>Результаты</CommonTitle>
                        <div className="garant-fond-results__col-8">
                            <CommonUsualText className="garant-fond-process__text">
                                Спустя 6 месяцев сотрудничества видно, что основные задачи по этому
                                проекту выполнены. Качественный контент-маркетинг с точечной
                                интеграцией таргетинга обеспечил стабильный рост активности в
                                официальных сообществах Гарантийного фонда.
                            </CommonUsualText>
                            <div className="garant-fond-results__subtitle mt-60">
                                Промежуточные результаты за 6 месяцев
                            </div>
                            <div className="garant-fond-results-now">
                                <CommonUsualText className="garant-fond-process__text">
                                    Команда «Вебпрактик» продолжает работу с социальными сетями
                                    Гарантийного Фонда Ростовской области.
                                </CommonUsualText>
                            </div>
                        </div>
                        <div className="garant-fond-results-indicators">
                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">
                                        Публикаций
                                    </div>
                                    <img
                                        src="/images/pic/garant-fond/pen.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">184</div>
                            </div>

                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">
                                        Просмотров
                                    </div>
                                    <img
                                        src="/images/pic/garant-fond/eye.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">134 315</div>
                            </div>
                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">Лайков</div>
                                    <img
                                        src="/images/pic/garant-fond/like.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">2 230</div>
                            </div>
                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">
                                        Новых подписчиков
                                    </div>
                                    <img
                                        src="/images/pic/garant-fond/sub.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">+371</div>
                            </div>
                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">
                                        Средний охват пользователей
                                    </div>
                                    <img
                                        src="/images/pic/garant-fond/users.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">294</div>
                            </div>
                            <div className="garant-fond-indicators-item">
                                <div className="garant-fond-indicators-item__head">
                                    <div className="garant-fond-indicators-item__title">
                                        Репостов
                                    </div>
                                    <img
                                        src="/images/pic/garant-fond/repost.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="garant-fond-indicators-item__num">118</div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        );
    }
}

export default Results;
